'use strict';

var NewCalibrationReviewParametersDirective = function NewCalibrationReviewParametersDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/new-calibration-review-parameters.html'),
    link: function link(scope, element) {
      element.find('.gdpr-popover').popover();
    },
    requires: '^rmNewCalibrationAnalysis',
    scope: false
  };
};
NewCalibrationReviewParametersDirective.$inject = [];
module.exports = NewCalibrationReviewParametersDirective;